import { List as IList } from 'immutable';

import { createSelector } from 'reselect';
import { programStepCompleted } from '../program/programStepSelectors';
import { cardTypeStepCompleted } from '../cardType/cardTypeStepSelectors';
import { getFlowProgress, getPreferredFaceplateCode } from '../routing/flowSelectors';
import { FACEPLATE_FIELD } from '../item/newItemForm';


export const designStepCompleted = createSelector(
    getFlowProgress,
    flowState => flowState.has(FACEPLATE_FIELD)
);


export const designStepPreConditions = IList([
    programStepCompleted,
    cardTypeStepCompleted
]);


export const designStepPostConditions = IList([
    designStepCompleted
]);

export const designStepSkippable = createSelector(
    getPreferredFaceplateCode,
    preferredFaceplateCode => (
        !!preferredFaceplateCode
    )
);
